import React, { PropsWithChildren, HTMLProps } from "react";
import Typography from "common/Typography/Typography";
import { FixMeLater } from "types";
import { typography } from "@shared/common/Themes/typography";
import { TypographyProps } from "@shared/common/Typography/Typography";
import { useTheme } from "styled-components";

interface TitleProps
  extends PropsWithChildren<TypographyProps>,
    Omit<HTMLProps<HTMLDivElement>, "type"> {
  level?: number;
  innerRef?: any;
  as?: any;
  className?: string;
}

const Title: React.FunctionComponent<TitleProps> = React.forwardRef(
  (
    {
      as,
      type = "primary",
      $weight,
      $size,
      level = 1,
      innerRef,
      className,
      ...props
    },
    ref
  ) => {
    const { isNewLook } = useTheme();
    const isHeading = level <= 3;
    const hTag = `h${level}`;
    let size = $size || hTagToSize[hTag];
    return (
      <Typography
        className={className}
        as={as || hTag}
        type={isNewLook && isHeading && type === "secondary" ? "primary" : type}
        $weight={
          $weight ??
          (isNewLook && isHeading
            ? typography.fontWeights.SEMI_BOLD
            : typography.fontWeights.MEDIUM)
        }
        $size={size}
        ref={innerRef || ref}
        {...props}
      />
    );
  }
);

const hTagToSize: FixMeLater = {
  h1: typography.fontSizes.XXL,
  h2: typography.fontSizes.XL,
  h3: typography.fontSizes.L,
  h4: typography.fontSizes.M,
  h5: typography.fontSizes.S,
};

export default Title;
